<section
  class="ui-contact-list"
  [class.ui-contact-list--form]="formOpen()"
>
  @if (formOpen()) {
    <header class="ui-contact-list__form-header">
      <h2 class="ui-contact-list__form-title">Nuevo contacto</h2>
      <div class="ui-contact-list__form-actions">
        <ui-button variant="secondary" size="md" (pressed)="onFormClose()">
          Cerrar
        </ui-button>
        <ui-button variant="primary" size="md" (pressed)="onContactSave()">
          Guardar
        </ui-button>
      </div>
    </header>

    <div class="ui-contact-list__form">
      <ui-form-section class="ui-contact-list__form-generales" title="Generales">
        <div class="ui-contact-list__generales">
          <div class="ui-contact-list__photo-slot">
            <ui-identity-photo-capture
              class="ui-contact-list__photo"
              label="Foto"
              description=""
              [showOptionalHint]="true"
              [block]="true"
              sourceMode="file"
              buttonLabel="Cargar foto"
              retakeLabel="Cambiar foto"
              clearLabel="Eliminar foto"
              placeholder="Sin foto"
              previewAlt="Foto del contacto"
              [resetKey]="photoResetKey()"
              (photoSelected)="onPhotoSelected($event)"
              (photoCleared)="onPhotoCleared()"
            />
          </div>

          <div class="ui-contact-list__generales-fields">
            <ui-input
              label="Nombre completo"
              placeholder="Nombre completo"
              [required]="true"
              [block]="true"
              [(value)]="fullName"
            />
            <div class="ui-contact-list__generales-row">
              <ui-input
                label="Departamento"
                placeholder="Departamento"
                [required]="true"
                [block]="true"
                [(value)]="department"
              />
              <ui-input
                label="Puesto"
                placeholder="Puesto"
                [required]="true"
                [block]="true"
                [(value)]="position"
              />
            </div>
          </div>
        </div>
      </ui-form-section>

      <div class="ui-contact-list__form-channels-slot">
        <ui-form-section
          class="ui-contact-list__form-channels"
          title="Medios de contacto"
          [fill]="true"
          [showAddButton]="true"
          addLabel="Nuevo"
          (addClick)="onNewChannel()"
        >
          <ui-compact-list
            [columns]="channelColumns"
            [rows]="channels()"
            rowKey="id"
            emptyText="No se han agregado medios de contacto"
            (edit)="onEditChannel($event)"
            (delete)="onDeleteChannel($event)"
          />
        </ui-form-section>
      </div>

      <ui-form-section
        class="ui-contact-list__form-notifications"
        title="Notificaciones"
      >
        <div class="ui-contact-list__notification-list">
          @for (option of notificationOptions(); track option.id) {
            <ui-checkbox
              [label]="option.label"
              [checked]="isNotificationSelected(option.id)"
              (checkedChange)="onNotificationChange(option.id, $event)"
            />
          }
        </div>
      </ui-form-section>
    </div>
  } @else {
  <div class="ui-contact-list__toolbar">
    <div class="ui-contact-list__toolbar-start">
      <button
        type="button"
        class="ui-contact-list__excel"
        [uiTooltip]="'Exportar a Excel'"
        uiTooltipPosition="top"
        aria-label="Exportar a Excel"
        (click)="exportExcel.emit()"
      >
        <img
          src="icons/ic_excel.svg"
          alt=""
          width="20"
          height="19"
          aria-hidden="true"
        />
      </button>
    </div>

    <div class="ui-contact-list__toolbar-end">
      <ui-select
        class="ui-contact-list__page-size"
        [showLabel]="false"
        [showSearch]="false"
        [allowClear]="false"
        [options]="pageSizeOptions"
        [selected]="selectedSizeOption()"
        (selectedChange)="onPageSizeChange($event)"
        [style.width.px]="145"
      />

      <ui-input
        class="ui-contact-list__search"
        kind="search"
        label="Buscar"
        placeholder="Buscar contactos"
        [showLabel]="false"
        [showOptionalHint]="false"
        [value]="search()"
        (valueChange)="onSearch($event)"
      />

      @if (showNewButton()) {
        <ui-button (click)="onNew()">{{ newLabel() }}</ui-button>
      }
    </div>
  </div>

  <div class="ui-contact-list__scroll">
    @if (pagedItems().length) {
      <div class="ui-contact-list__grid">
        @for (contact of pagedItems(); track contact.id; let idx = $index) {
          <article class="ui-contact-list__card">
            <div class="ui-contact-list__card-top">
              <ui-avatar
                [imageSrc]="contact.photoUrl ?? null"
                [label]="contact.name"
                [imageAlt]="contact.name"
                [ariaLabel]="contact.name"
                size="lg"
                shape="circle"
              />

              <button
                type="button"
                class="ui-contact-list__action-trigger"
                [class.ui-contact-list__action-trigger--open]="
                  actionMenu()?.rowIndex === idx
                "
                [attr.aria-label]="'Acciones de ' + contact.name"
                [attr.aria-expanded]="actionMenu()?.rowIndex === idx"
                aria-haspopup="menu"
                (click)="toggleActionMenu($event, contact, idx)"
              >
                ⋮
              </button>
            </div>

            <h3 class="ui-contact-list__name" [title]="contact.name">
              {{ contact.name }}
            </h3>
            <p class="ui-contact-list__email" [title]="contact.email">
              {{ contact.email }}
            </p>
            <p class="ui-contact-list__phone" [title]="contact.phone">
              {{ contact.phone }}
            </p>
            <div class="ui-contact-list__tags">
              <ui-tag [label]="contact.department" color="info" />
              <ui-tag [label]="contact.position" color="neutral" />
            </div>
            <p class="ui-contact-list__notifications">
              Notificaciones
              <span>{{ contact.notifications }}</span>
            </p>
          </article>
        }
      </div>
    } @else {
      <p class="ui-contact-list__empty">No se encontraron contactos.</p>
    }
  </div>

  <ui-data-table-pagination
    [currentPage]="safePage()"
    [totalPages]="totalPages()"
    [visiblePages]="visiblePages()"
    [rangeStart]="rangeStart()"
    [rangeEnd]="rangeEnd()"
    [total]="total()"
    (pageSelect)="goToPage($event)"
  />
  }
</section>

@if (actionMenu(); as menu) {
  <ui-data-table-actions-menu
    [state]="menu"
    [items]="menu.items"
    (actionSelect)="onActionSelect($event)"
  />
}

<ui-drawer
  [(open)]="channelDrawerOpen"
  [title]="channelDrawerTitle()"
  cancelLabel="Cerrar"
  saveLabel="Guardar"
  panelWidth="640px"
  (saved)="onChannelSave()"
>
  <div class="ui-contact-list__fields">
    <ui-select
      label="Tipo"
      [required]="true"
      [block]="true"
      [options]="channelTypeOptions"
      [(selected)]="channelType"
    />
    @if (isPhoneChannel()) {
      <ui-phone-input
        label="Dato"
        [required]="true"
        [block]="true"
        [(phoneNumber)]="channelValue"
      />
    } @else if (isEmailChannel()) {
      <ui-input
        label="Dato"
        kind="email"
        [required]="true"
        [block]="true"
        [(value)]="channelValue"
      />
    } @else {
      <ui-input
        label="Dato"
        kind="text"
        placeholder="Dato"
        [required]="true"
        [block]="true"
        [(value)]="channelValue"
      />
    }
  </div>
</ui-drawer>
